import { CycleUtils, getSearchParams, UrlUtils } from '@wix/package-picker-shared';
import { SwitchProductModule } from '@wix/package-picker-sdk';
import { useEffect } from 'react';
import { useAnonymous } from './useAnonymous';
import { useCurrentModule } from '../components/ModuleProvider';
import { EclipsePackagePickerSteps } from '../types/types';
const VALID_CYCLES = new Set(['MONTHLY', 'QUARTERLY', 'YEARLY', 'YEAR2', 'YEAR3', 'YEAR4', 'YEAR5']);
function resolveTargetCycle(cycleId, paymentCycle) {
  if (cycleId != null) {
    return CycleUtils.convertCycleIdToCycle(cycleId);
  }
  if (paymentCycle != null && VALID_CYCLES.has(paymentCycle)) {
    return CycleUtils.convertPaymentCycle(paymentCycle);
  }
  return null;
}
export const INTENTS = {
  CYCLE_UPSALE: 'cycle-upsale-intent',
  ABANDONED_CART: 'abandoned-cart-intent'
};
export const isDeepLinkApplicable = _ref => {
  let {
    step,
    isAnonymous,
    targetCycle,
    isCycleUpsaleIntent,
    isAbandonedCartIntent,
    urlProductId
  } = _ref;
  return step === EclipsePackagePickerSteps.SELECT_PLAN && !isAnonymous && targetCycle != null && (isCycleUpsaleIntent || isAbandonedCartIntent && urlProductId != null);
};
export const useCheckoutDeepLink = step => {
  var _currentProductData$c, _offering$products;
  const module = useCurrentModule();
  const {
    setSelectedProductId,
    setSelectedCycleId
  } = module.SDK.PackagePickerStore;
  const changeRoute = module.internals.hooks.useChangeRoute();
  const {
    isAnonymous
  } = useAnonymous();
  const {
    productId: urlProductId,
    cycleId,
    paymentCycle,
    referralAdditionalInfo
  } = getSearchParams();
  const targetCycle = resolveTargetCycle(cycleId, paymentCycle);
  const isCycleUpsaleIntent = referralAdditionalInfo === INTENTS.CYCLE_UPSALE;
  const isAbandonedCartIntent = referralAdditionalInfo === INTENTS.ABANDONED_CART;
  const isApplicable = isDeepLinkApplicable({
    step,
    isAnonymous,
    targetCycle,
    isCycleUpsaleIntent,
    isAbandonedCartIntent,
    urlProductId
  });

  // Always called — hooks can't be conditional. Only used when isCycleUpsaleIntent.
  const {
    data: currentProductData,
    isLoading: isCurrentProductLoading
  } = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const currentFamilyId = currentProductData == null || (_currentProductData$c = currentProductData.currentProduct) == null ? void 0 : _currentProductData$c.productFamilyId;
  const {
    data: offering,
    isLoading: isOfferingLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const cycleUpsaleProductId = (offering == null || (_offering$products = offering.products) == null || (_offering$products = _offering$products.find(p => p.productFamilyId === currentFamilyId)) == null ? void 0 : _offering$products.productId) ?? null;
  const resolvedProductId = isCycleUpsaleIntent ? cycleUpsaleProductId : urlProductId ?? null;
  const isResolvingProductId = isCycleUpsaleIntent && (isCurrentProductLoading || isOfferingLoading);
  const isReady = isApplicable && !isResolvingProductId && resolvedProductId != null;
  useEffect(() => {
    if (!isReady || !resolvedProductId || !targetCycle || !referralAdditionalInfo) {
      return;
    }
    setSelectedProductId(resolvedProductId);
    setSelectedCycleId(CycleUtils.convertCycleToCycleId(targetCycle));
    UrlUtils.replaceSearchParam('referralAdditionalInfo', `${referralAdditionalInfo}-consumed`);
    changeRoute(EclipsePackagePickerSteps.CHECKOUT);
  }, [isReady, resolvedProductId, targetCycle, referralAdditionalInfo, setSelectedProductId, setSelectedCycleId, changeRoute]);
  return {
    isActive: isApplicable && (isResolvingProductId || isReady)
  };
};
//# sourceMappingURL=useCheckoutDeepLink.js.map